export const resumeData = {
  en: {
    personalInfo: {
      name: "Woravut Dairoop",
      roles: ["Full-Stack Developer"],
      company: "Bigmall Plus",
      email: "woravutdairoop.work@gmail.com",
      phone: "+66 62 610 0297",
      status: "Open to Opportunities",
    },
    stats: [
      { label: "Years Experience", value: 1, suffix: "+" },
      { label: "Projects Delivered", value: 6, suffix: "" },
      { label: "Awards Won", value: 2, suffix: "" },
      { label: "Technologies", value: 8, suffix: "+" },
    ],
    professionalSummary: "Full-stack developer with a strong background in Data Science and over 1 year of full-stack development experience. Proven track record of developing and deploying robust production web systems, including a Warehouse Management System (WMS) and enterprise internal portals at Bigmall Plus. Expert in React, Next.js, Node.js, and SQL, with hands-on expertise in database design, API engineering, AI agent tooling with MCP, and secure Linux server deployments (Nginx, PM2).",
    education: [
      {
        degree: "Bachelor of Science in Data Science",
        institution: "Silpakorn University",
        period: "2020 - 2025"
      }
    ],
    experience: [
      {
        title: "Fullstack Developer",
        company: "Freelance",
        period: "May 2026 – Present",
        techStack: "Tech: React, Next.js, Node.js, TypeScript, PostgreSQL, MySQL, Prisma",
        description: "Full-stack web development and deployment for clients across multiple industries, managing full project lifecycle from scoping to production release.",
        highlights: [
          "Designed and developed end-to-end web applications for clients across multiple industries using React, Next.js, Node.js, and TypeScript",
          "Configured and managed production environments including VPS setup, Nginx reverse proxy, SSL/TLS certificates, and PM2 process management",
          "Architected relational database schemas using PostgreSQL, MySQL, and SQLite with Prisma ORM, ensuring data integrity and optimized query performance",
          "Gathered requirements and provided technical consultations, iterating on deliverables to align with client goals"
        ]
      },
      {
        title: "Fullstack / Data Analyst",
        company: "Bigmall Plus",
        period: "Jun 2025 – May 2026",
        techStack: "Tech: Next.js, React, Prisma, SQLite, Tailwind CSS, Power BI",
        description: "Multi-role position encompassing full-stack web development, and business data analytics.",
        highlights: [
          "Developed and deployed a production-grade Internal WMS Portal, streamlining daily corporate workflows and warehouse operations for staff",
          "Designed and normalized a relational database schema with 20+ tables managing HR, payroll, inventory tracking, and operational claims",
          "Engineered secure Next.js Server Actions with role-based access control (RBAC), securing 11 distinct administrative sub-systems",
          "Collaborated closely with cross-departmental teams to translate complex business workflows into scalable system features",
          "Automated deployment processes and optimized uptime for Next.js applications on Linux servers using PM2 process manager",
          "Configured secure network infrastructures, Nginx reverse proxies, and SSL certificates to protect internal data",
          "Created interactive Power BI dashboards to visualize key supply chain and operational analytics, facilitating data-driven executive decisions",
          "Supported internal IT infrastructure, managing network configurations and hardware maintenance to ensure zero business disruption"
        ]
      },
      {
        title: "Student Union Advisor",
        company: "Faculty of Science, Silpakorn University",
        period: "2024",
        techStack: "Leadership & Coaching",
        description: "Mentored the succeeding student council, providing strategic guidance.",
        highlights: [
          "Advised on event planning and budget management",
          "Facilitated smooth leadership transition between terms"
        ]
      },
      {
        title: "President",
        company: "Student Union, Faculty of Science, Silpakorn University",
        period: "2023",
        techStack: "Management & Planning",
        description: "Led student organization operations and coordinated university events.",
        highlights: [
          "Managed event planning and budgeting for multiple faculty activities"
        ]
      }
    ],
    projects: [
      {
        title: "Data Science & AI Department Website + CMS",
        impact: "Bilingual (TH/EN) website and custom admin CMS for the Department of Data Science and AI, Silpakorn University.",
        techStack: "Tech: Next.js 16, React 19, TypeScript, Prisma 7, PostgreSQL, Tailwind CSS v4, Docker",
        tech: ["Next.js 16", "TypeScript", "Prisma 7", "PostgreSQL", "Docker"],
        period: "Jul 2026 – Oct 2026",
        status: "development",
        image: "/assets/DSSU.png",
        highlights: [
          "Built a bilingual public site where every editorial section (programs, admission, news, research, people, FAQ) is editable from a custom admin panel",
          "Implemented signed HttpOnly session auth with bcrypt and role-based access (admin/editor), plus per-request CSP nonce and CSRF origin checks",
          "Added a draft/publish workflow, media library, automatic content snapshots with restore/import/export, and an activity audit log",
          "Developed 20+ API routes and a static-export pipeline deployed to Firebase Hosting, with self-hosted pageview analytics and GA4"
        ]
      },
      {
        title: "\"Nong Wanmai\" RAG Chatbot (Quitline)",
        impact: "AI chatbot answering quit-smoking questions on the web and LINE Official Account.",
        techStack: "Tech: Python, FastAPI, ChromaDB, BGE-M3, LLM API, PostgreSQL, LINE Messaging API, Nginx",
        tech: ["Python", "FastAPI", "ChromaDB", "RAG", "LINE OA"],
        period: "2026",
        status: "development",
        image: "/assets/Wanmai_chatbot.png",
        highlights: [
          "Built a retrieval-augmented chatbot using BGE-M3 embeddings and ChromaDB, sending only retrieved passages to the LLM",
          "Integrated web chat and LINE OA channels behind a FastAPI service with Nginx reverse proxy",
          "Logged KPIs and chat history to PostgreSQL and built an admin dashboard for KPIs, chat inbox, retention and daily-limit settings",
          "Routed callback requests into the CMS leads pipeline, with PDPA consent logging"
        ]
      },
      {
        title: "Quitline 1600 CMS",
        impact: "Full-stack digital quit-smoking support platform with a public site and a complete back-office admin CMS.",
        techStack: "Tech: Next.js 16, Prisma, PostgreSQL, Tailwind CSS v4, bcryptjs",
        tech: ["Next.js 16", "Prisma", "PostgreSQL", "Tailwind CSS v4", "bcryptjs"],
        period: "2026",
        status: "development",
        image: "/assets/Quitline_1600.png",
        highlights: [
          "Built a public site featuring articles, a self-assessment tool, savings calculator, quit-streak tracker, and callback request form",
          "Designed a 9-table relational database (Prisma + PostgreSQL) and built 18+ RESTful API endpoints powering articles, banners, media library, streak tracking, and PDPA consent logging",
          "Developed 13+ admin pages with role-based access control (superadmin/editor/staff) and activity/audit logging",
          "Implemented a soft-delete media library with scheduled purge and LINE Login for public users"
        ]
      },
      {
        title: "Academic Department CMS",
        impact: "Full-stack content management system for managing department website content.",
        techStack: "Tech: Next.js, Prisma, SQLite",
        tech: ["Next.js", "Prisma", "SQLite"],
        period: "Mar 2026 - May 2026",
        status: "production",
        link: "https://chem.sc.su.ac.th",
        image: "/assets/Chem_SCSU.png",
        highlights: [
          "Built a full-stack CMS for managing department website content including news, staff profiles, and research publications",
          "Designed relational database schema with 13 tables using Prisma ORM",
          "Developed 20+ admin pages and 15+ REST API endpoints",
          "Implemented authentication, audit logging, and rich text editing"
        ]
      },
      {
        title: "Bigmall Plus WMS & Internal Portal",
        impact: "Internal system used by warehouse and corporate staff for daily operations.",
        techStack: "Tech: Next.js, React, Prisma, Tailwind CSS",
        tech: ["Next.js", "React", "Prisma", "Tailwind CSS"],
        period: "Jul 2025 – May 2026",
        status: "production",
        image: "/assets/Bigmallplus.png",
        highlights: [
          "Built a full-stack internal portal encompassing Warehouse Claims, HR Management, Payroll, and Equipment Tracking",
          "Developed 11 distinct corporate modules with role-based access control and real-time activity dashboards",
          "Created operational dashboards using Power BI to visualize supply chain metrics"
        ]
      },
      {
        title: "NLP Poetry Generator",
        impact: "Natural language processing pipeline for classical Thai poetry.",
        techStack: "Tech: Python, Deep Learning, TensorFlow",
        tech: ["Python", "NLP", "TensorFlow"],
        period: "Nov 2024 – Mar 2025",
        status: "completed",
        noPreview: true,
        highlights: [
          "Developed NLP pipeline for processing Sunthorn Phu's classical poetry",
          "Built corpus construction, tokenization, and deep learning models for generation"
        ]
      }
    ],
    awards: [
      {
        title: "Phra Chan Phet Award (Diamond Moon Award)",
        description: "Recognized as an Outstanding Student Activity Leader of the university for exemplary planning and execution of faculty events.",
        year: "2024"
      },
      {
        title: "Phra Chan Phet Award (Diamond Moon Award)",
        description: "Honored for consecutive years of outstanding leadership and management in student council operations.",
        year: "2025"
      }
    ],
    certificates: [
      {
        title: "AI Fundamentals: Unlocking New Opportunities in Life and Work",
        issuer: "National Board of Digital Economy and Society Office (Thai AI Passport)",
        date: "Sep 2026",
        image: "/assets/certificate-ai-fundamentals-1.jpeg"
      },
      {
        title: "How Does AI Learn? A Simple Explanation",
        issuer: "National Board of Digital Economy and Society Office (Thai AI Passport)",
        date: "Sep 2026",
        image: "/assets/certificate-ai-how-it-learns.jpeg"
      },
      {
        title: "How Generative AI and ChatGPT Work",
        issuer: "National Board of Digital Economy and Society Office (Thai AI Passport)",
        date: "Sep 2026",
        image: "/assets/certificate-generative-ai-chatgpt.jpeg"
      },
      {
        title: "AI Fundamentals: Essential Skills for the AI Era",
        issuer: "National Board of Digital Economy and Society Office (Thai AI Passport)",
        date: "Sep 2026",
        image: "/assets/certificate-ai-fundamentals-2.jpeg"
      },
      {
        title: "Adapting to the New Era of Work with AI",
        issuer: "National Board of Digital Economy and Society Office (Thai AI Passport)",
        date: "Sep 2026",
        image: "/assets/certificate-ai-adapting-to-work.jpeg"
      }
    ],
    sections: {
      summary: "PROFESSIONAL SUMMARY",
      education: "EDUCATION",
      analytics: "SKILLS",
      experience: "EXPERIENCE",
      projects: "PROJECTS",
      awards: "AWARDS & ACHIEVEMENTS",
      certificates: "CERTIFICATES",
      contact: "CONTACT"
    }
  },
  th: {
    personalInfo: {
      name: "นายวรวุฒิ ได้รูป",
      roles: ["นักพัฒนา Full-Stack"],
      company: "Bigmall Plus",
      email: "woravutdairoop.work@gmail.com",
      phone: "+66 62 610 0297",
      status: "เปิดรับโอกาสงานใหม่",
    },
    stats: [
      { label: "ปีประสบการณ์", value: 1, suffix: "+" },
      { label: "โปรเจกต์ที่ส่งมอบ", value: 6, suffix: "" },
      { label: "รางวัลที่ได้รับ", value: 2, suffix: "" },
      { label: "เทคโนโลยี", value: 8, suffix: "+" },
    ],
    professionalSummary: "นักพัฒนา Full-stack ที่มีทักษะระดับสูงในด้านวิทยาศาสตร์ข้อมูล (Data Science) และมีประสบการณ์พัฒนา Full-stack มากกว่า 1 ปี มีความเชี่ยวชาญในการออกแบบ พัฒนา และ Deploy ระบบ Web Application ระดับ Production ที่รองรับกระบวนการทำงานจริง เช่น ระบบบริหารจัดการคลังสินค้า (WMS) และระบบพอร์ทัลภายในของบริษัท Bigmall Plus เชี่ยวชาญเทคโนโลยี React, Next.js, Node.js และ SQL ตลอดจนการออกแบบ Database Schema โครงสร้าง API การพัฒนาเครื่องมือ AI Agent ด้วย MCP และการดูแลระบบ Linux Server (Nginx, PM2)",
    education: [
      {
        degree: "วิทยาศาสตรบัณฑิต สาขาวิทยาศาสตร์ข้อมูล",
        institution: "มหาวิทยาลัยศิลปากร",
        period: "2563 - 2568"
      }
    ],
    experience: [
      {
        title: "นักพัฒนา Full-Stack",
        company: "รับงานอิสระ (Freelance)",
        period: "พ.ค. 2569 – ปัจจุบัน",
        techStack: "Tech: React, Next.js, Node.js, TypeScript, PostgreSQL, MySQL, Prisma",
        description: "พัฒนาและ Deploy เว็บแอปพลิเคชัน Full-stack ให้ลูกค้าหลากหลายอุตสาหกรรม ดูแลตั้งแต่การรวบรวมความต้องการจนถึงการนำระบบขึ้นใช้งานจริง",
        highlights: [
          "ออกแบบและพัฒนาเว็บแอปพลิเคชันแบบ End-to-End ให้ลูกค้าหลากหลายอุตสาหกรรม ด้วย React, Next.js, Node.js และ TypeScript",
          "ตั้งค่าและดูแล Production Environment ครอบคลุมการติดตั้ง VPS, Nginx Reverse Proxy, SSL/TLS Certificates และ PM2 Process Management",
          "ออกแบบโครงสร้างฐานข้อมูลเชิงสัมพันธ์ด้วย PostgreSQL, MySQL และ SQLite ร่วมกับ Prisma ORM เพื่อความถูกต้องและประสิทธิภาพของข้อมูล",
          "รวบรวมความต้องการและให้คำปรึกษาด้านเทคนิคแก่ลูกค้า ปรับปรุงงานส่งมอบให้ตรงตามเป้าหมายตลอดวงจรโปรเจกต์"
        ]
      },
      {
        title: "Fullstack / Data Analyst",
        company: "บริษัทบิ๊กมอลล์ พลัส",
        period: "มิ.ย. 2568 – พ.ค. 2569",
        techStack: "Tech: Next.js, React, Prisma, SQLite, Tailwind CSS, Power BI",
        description: "รับผิดชอบทั้งการพัฒนา Full-stack, วิเคราะห์ข้อมูลทางธุรกิจ และสนับสนุนโครงสร้างพื้นฐาน IT",
        highlights: [
          "พัฒนาและเริ่มใช้งานระบบ Internal WMS ในระดับ Production ช่วยเพิ่มความรวดเร็วและเป็นระบบให้กับทีมปฏิบัติงานและคลังสินค้าในทุกวัน",
          "ออกแบบโครงสร้างฐานข้อมูล (Database Schema) กว่า 20 Relational Tables ครอบคลุมระบบบริหารงานบุคคล, บัญชีเงินเดือน, การติดตามอุปกรณ์ และคลังสินค้า",
          "พัฒนา Next.js Server Actions ที่ปลอดภัยพร้อมระบบกำหนดสิทธิ์การเข้าถึง (RBAC) รองรับการทำงานของ 11 โมดูลหลักขององค์กร",
          "ร่วมมือกับผู้ใช้จริงฝ่ายต่าง ๆ เพื่อถอดรหัสขั้นตอนการทำงานจริงของธุรกิจและนำเสนอออกมาเป็นฟีเจอร์ในระบบที่ตอบโจทย์และใช้งานง่าย",
          "ตั้งค่าและ Deploy แอปพลิเคชัน Next.js บนระบบปฏิบัติการ Linux ด้วย PM2 เพื่อความเสถียรและประสิทธิภาพสูงสุดของระบบ",
          "ปรับแต่งความปลอดภัยของเว็บเซิร์ฟเวอร์ด้วย SSL Certificates และการทำ Reverse Proxy ผ่าน Nginx",
          "สร้าง Interactive Dashboard ด้วย Power BI ในการแปลงข้อมูลดิบของซัพพลายเชนเป็นข้อมูลวิเคราะห์เชิงลึกเพื่อการตัดสินใจของผู้บริหาร",
          "ดูแลรักษาระบบเครือข่าย ความปลอดภัย และฮาร์ดแวร์ IT ทั้งหมดของบริษัทเพื่อรักษาความมั่นคงในการทำงานของบุคลากรในองค์กร"
        ]
      },
      {
        title: "ที่ปรึกษาสโมสรนักศึกษา",
        company: "คณะวิทยาศาสตร์ มหาวิทยาลัยศิลปากร",
        period: "2567",
        techStack: "Leadership & Coaching",
        description: "ให้คำปรึกษาแก่สโมสรนักศึกษาชุดถัดไปในเชิญบริหารจัดการองค์กร",
        highlights: [
          "ให้คำปรึกษาด้านการวางแผนกิจกรรมและการจัดการงบประมาณหลัก",
          "ช่วยดูแลกระบวนการเปลี่ยนผ่านและวางระบบการบริหารผู้นำรุ่นต่อไป"
        ]
      },
      {
        title: "นายกสโมสรนักศึกษา",
        company: "สโมสรนักศึกษา คณะวิทยาศาสตร์ มหาวิทยาลัยศิลปากร",
        period: "2566",
        techStack: "Management & Planning",
        description: "บริหารจัดการสโมสรนักศึกษาและช่วยควบคุมการจัดกิจกรรมใหญ่ของคณะ",
        highlights: [
          "บริหารงานและวางแผนงบประมาณสำหรับกิจกรรมนักศึกษาทั้งคณะ"
        ]
      }
    ],
    projects: [
      {
        title: "เว็บไซต์ + CMS ภาควิชาวิทยาการข้อมูลและปัญญาประดิษฐ์",
        impact: "เว็บไซต์สองภาษา (TH/EN) พร้อมระบบหลังบ้าน CMS สำหรับภาควิชาวิทยาการข้อมูลและปัญญาประดิษฐ์ มหาวิทยาลัยศิลปากร",
        techStack: "Tech: Next.js 16, React 19, TypeScript, Prisma 7, PostgreSQL, Tailwind CSS v4, Docker",
        tech: ["Next.js 16", "TypeScript", "Prisma 7", "PostgreSQL", "Docker"],
        period: "ก.ค. 2569 – ต.ค. 2569",
        status: "development",
        image: "/assets/DSSU.png",
        highlights: [
          "สร้างเว็บไซต์สองภาษาที่ทุกส่วนเนื้อหา (หลักสูตร การรับสมัคร ข่าว งานวิจัย บุคลากร FAQ) แก้ไขได้จากระบบหลังบ้าน",
          "พัฒนาระบบยืนยันตัวตนด้วย Signed HttpOnly Session + bcrypt พร้อมสิทธิ์ตามบทบาท (admin/editor) และ CSP nonce / CSRF origin check ทุก request",
          "มีระบบ Draft/Publish คลังสื่อ Backup เนื้อหาอัตโนมัติพร้อม Restore/Import/Export และ Activity Audit Log",
          "พัฒนา API มากกว่า 20 routes และ Pipeline Static Export สำหรับ Deploy ขึ้น Firebase Hosting พร้อมสถิติผู้เข้าชมและ GA4"
        ]
      },
      {
        title: "แชตบอท \"น้องวันใหม่\" (RAG) — Quitline",
        impact: "แชตบอท AI ตอบคำถามเรื่องการเลิกบุหรี่ ทั้งบนเว็บและ LINE Official Account",
        techStack: "Tech: Python, FastAPI, ChromaDB, BGE-M3, LLM API, PostgreSQL, LINE Messaging API, Nginx",
        tech: ["Python", "FastAPI", "ChromaDB", "RAG", "LINE OA"],
        period: "2569",
        status: "development",
        image: "/assets/Wanmai_chatbot.png",
        highlights: [
          "สร้างแชตบอทแบบ Retrieval-Augmented Generation ด้วย BGE-M3 Embeddings และ ChromaDB ส่งเฉพาะเนื้อหาที่ค้นเจอให้ LLM",
          "เชื่อมช่องทางเว็บแชตและ LINE OA ผ่าน FastAPI Service หลัง Nginx Reverse Proxy",
          "บันทึก KPI และประวัติแชตลง PostgreSQL พร้อมหน้าหลังบ้านดู Dashboard KPI กล่องแชต และตั้งค่าระยะเก็บข้อมูล/เพดานคำตอบต่อวัน",
          "ส่งรายชื่อผู้ขอให้โทรกลับเข้าระบบ Leads ของ CMS พร้อมบันทึกความยินยอม PDPA"
        ]
      },
      {
        title: "Quitline 1600 CMS",
        impact: "แพลตฟอร์มสนับสนุนการเลิกบุหรี่แบบ Full-stack พร้อมเว็บไซต์สาธารณะและระบบหลังบ้าน CMS ครบวงจร",
        techStack: "Tech: Next.js 16, Prisma, PostgreSQL, Tailwind CSS v4, bcryptjs",
        tech: ["Next.js 16", "Prisma", "PostgreSQL", "Tailwind CSS v4", "bcryptjs"],
        period: "2569",
        status: "development",
        image: "/assets/Quitline_1600.png",
        highlights: [
          "สร้างเว็บไซต์สาธารณะประกอบด้วยบทความ แบบประเมินตนเอง เครื่องคำนวณเงินที่ประหยัดได้ ตัวติดตามการเลิกบุหรี่ต่อเนื่อง และแบบฟอร์มขอรับสาย",
          "ออกแบบฐานข้อมูลเชิงสัมพันธ์ 9 ตาราง (Prisma + PostgreSQL) และพัฒนา RESTful API มากกว่า 18 endpoints สำหรับบทความ แบนเนอร์ คลังสื่อ การติดตามสถิติ และการบันทึกความยินยอม PDPA",
          "พัฒนาหน้าหลังบ้านมากกว่า 13 หน้า พร้อมระบบสิทธิ์การเข้าถึงตามบทบาท (superadmin/editor/staff) และระบบบันทึกกิจกรรม/Audit Log",
          "ติดตั้งระบบคลังสื่อแบบ Soft-delete พร้อมลบถาวรตามกำหนดเวลา และระบบเข้าสู่ระบบด้วย LINE Login สำหรับผู้ใช้ทั่วไป"
        ]
      },
      {
        title: "Academic Department CMS",
        impact: "ระบบบริหารเนื้อหา (CMS) แบบ Full-stack สำหรับจัดการเว็บไซต์ของภาควิชา",
        techStack: "Tech: Next.js, Prisma, SQLite",
        tech: ["Next.js", "Prisma", "SQLite"],
        period: "มี.ค. 2569 – พ.ค. 2569",
        status: "production",
        link: "https://chem.sc.su.ac.th",
        image: "/assets/Chem_SCSU.png",
        highlights: [
          "สร้าง CMS แบบ Full-stack ระบบใหญ่สำหรับจัดการข้อมูลหน้าเว็บ ข่าวสาร ประวัติอาจารย์ และงานวิจัย",
          "ออกแบบ Relational Database Schema จาก 13 Tables พร้อมใช้ Prisma ORM เชื่อมต่อข้อมูล",
          "พัฒนาระบบหลังบ้านมากกว่า 20+ หน้า และสร้าง 15+ REST API endpoints สำหรับเรียกใช้งาน",
          "ติดตั้งระบบยืนยันตัวตน, Audit Logs สำหรับบันทึกประวัติการกระทำ และระบบ Rich Text Formatting"
        ]
      },
      {
        title: "Bigmall Plus WMS & Internal Portal",
        impact: "ระบบภายในที่ใช้งานจริงโดยทีมปฏิบัติการคลังสินค้าและบุคลากรองค์กรในกระบวนการทำงานทุกวัน",
        techStack: "Tech: Next.js, React, Prisma, Tailwind CSS",
        tech: ["Next.js", "React", "Prisma", "Tailwind CSS"],
        period: "ก.ค. 2568 – พ.ค. 2569",
        status: "production",
        image: "/assets/Bigmallplus.png",
        highlights: [
          "พัฒนาระบบภายในแบบ Full-stack ครอบคลุมระบบคลังสินค้า ระบบบุคคลากร และระบบเงินเดือน",
          "ออกแบบและพัฒนา 11 โมดูลการทำงาน พร้อมระบบ Role-based Access Control เชื่อมกับพนักงานจริง",
          "เชื่อมต่อข้อมูลระบบการแสดงผลรายงานด้วย Power BI ในระดับการบริหารซัพพลายเชนรายเดือน"
        ]
      },
      {
        title: "NLP Poetry Generator",
        impact: "ระบบ Pipeline ประมวลผลภาษาธรรมชาติ (NLP) สำหรับวิเคราะห์กวีนิพนธ์ไทยแบบคลาสสิก",
        techStack: "Tech: Python, Deep Learning, TensorFlow",
        tech: ["Python", "NLP", "TensorFlow"],
        period: "พ.ย. 2567 – มี.ค. 2568",
        status: "completed",
        noPreview: true,
        highlights: [
          "พัฒนาระบบวิเคราะห์ภาษาสำหรับการถอดรหัสและประมวลผลกวีนิพนธ์ของสุนทรภู่",
          "เขียนโปรแกรมสำหรับจัดทำ Corpus, ตัดคำ, และพัฒนา Deep Learning Model เพื่อสร้างบทกวีใหม่"
        ]
      }
    ],
    awards: [
      {
        title: "รางวัลพระจันทร์เพชร",
        description: "ได้รับรางวัลผู้ทำกิจกรรมระดับดีเด่น ประจำปีการศึกษา 2567 จากมหาวิทยาลัยศิลปากร ด้านการบริหารงานและวางแผนกิจกรรมคณะ",
        year: "2567"
      },
      {
        title: "รางวัลพระจันทร์เพชร",
        description: "ได้รับรางวัลผู้ทำกิจกรรมระดับดีเด่น ประจำปีการศึกษา 2568 ต่อเนื่องเป็นปีที่สอง จากการนำสโมสรนักศึกษาและสร้างกิจกรรมที่เป็นประโยชน์แก่สังคม",
        year: "2568"
      }
    ],
    certificates: [
      {
        title: "พื้นฐาน AI: เปิดโลก AI สู่โอกาสใหม่ในชีวิตและงาน",
        issuer: "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (Thai AI Passport)",
        date: "ก.ย. 2569",
        image: "/assets/certificate-ai-fundamentals-1.jpeg"
      },
      {
        title: "AI เรียนรู้อย่างไร? เปิดเผยเบื้องหลังแบบเข้าใจง่าย",
        issuer: "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (Thai AI Passport)",
        date: "ก.ย. 2569",
        image: "/assets/certificate-ai-how-it-learns.jpeg"
      },
      {
        title: "Generative AI และ ChatGPT ทำงานอย่างไร",
        issuer: "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (Thai AI Passport)",
        date: "ก.ย. 2569",
        image: "/assets/certificate-generative-ai-chatgpt.jpeg"
      },
      {
        title: "พื้นฐาน AI: ทักษะจำเป็นในยุค AI",
        issuer: "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (Thai AI Passport)",
        date: "ก.ย. 2569",
        image: "/assets/certificate-ai-fundamentals-2.jpeg"
      },
      {
        title: "การปรับตัวสู่การทำงานยุคใหม่กับ AI",
        issuer: "สำนักงานคณะกรรมการดิจิทัลเพื่อเศรษฐกิจและสังคมแห่งชาติ (Thai AI Passport)",
        date: "ก.ย. 2569",
        image: "/assets/certificate-ai-adapting-to-work.jpeg"
      }
    ],
    sections: {
      summary: "บทสรุปวิชาชีพ",
      education: "ประวัติการศึกษา",
      analytics: "ทักษะด้านเทคโนโลยี",
      experience: "ประสบการณ์ทำงานจริง",
      projects: "โปรเจกต์สำคัญ",
      awards: "รางวัลและความสำเร็จ",
      certificates: "ใบประกาศนียบัตร",
      contact: "ช่องทางติดต่อ"
    }
  }
};

export const skills = [
  {
    name: "Frontend",
    category: { en: "Web UI", th: "ส่วนติดต่อผู้ใช้" },
    useCase: { en: "React, Next.js, TypeScript, HTML, CSS", th: "React, Next.js, TypeScript, HTML, CSS" },
    color: "from-blue-400 to-cyan-400"
  },
  {
    name: "Backend",
    category: { en: "Server & API", th: "เซิร์ฟเวอร์ & โครงสร้าง API" },
    useCase: { en: "Node.js, Express, TypeScript, REST API", th: "Node.js, Express, TypeScript, REST API" },
    color: "from-green-400 to-emerald-500"
  },
  {
    name: "Database",
    category: { en: "Data Management", th: "การจัดการฐานข้อมูล" },
    useCase: { en: "MySQL, SQLite, Prisma ORM", th: "MySQL, SQLite, Prisma ORM" },
    color: "from-slate-400 to-blue-400"
  },
  {
    name: "Data & Analytics",
    category: { en: "Analysis & Visuals", th: "การวิเคราะห์และแสดงผลข้อมูล" },
    useCase: { en: "Python, Pandas, Power BI", th: "Python, Pandas, Power BI" },
    color: "from-yellow-400 to-orange-400"
  },
  {
    name: "Tools & DevOps",
    category: { en: "Infrastructure", th: "เครื่องมือและโครงสร้าง" },
    useCase: { en: "Git, Linux, Docker, SSL configuration, Reverse proxy", th: "Git, Linux, Docker, ตั้งค่า SSL, Reverse proxy" },
    color: "from-purple-400 to-pink-500"
  },
  {
    name: "AI Agent Tooling",
    category: { en: "MCP & Code Analysis", th: "MCP และวิเคราะห์โค้ด" },
    useCase: { en: "Model Context Protocol, tree-sitter, static analysis", th: "Model Context Protocol, tree-sitter, static analysis" },
    color: "from-indigo-400 to-violet-500"
  }
];

export const socialLinks = {
  github: "https://github.com/6ixthxense",
  portfolio: "https://resume-mmicky-y.web.app",
  linkedin: "https://www.linkedin.com/in/woravut-dairoop-13972b1b9/",
  fastwork: "https://fastwork.com/user/devhub",
  email: "woravutdairoop.work@gmail.com"
};
